import React from 'react';
import {
    Bar,
    BarChart,
    Area,
    AreaChart,
    Line,
    LineChart,
    ResponsiveContainer,
} from 'recharts';
import {
    data,
    data1,
    data2,
} from './data';
import { history } from 'store';
import ChartCard from 'components/dashboard/Common/ChartCard';
import ContainerHeader from 'components/ContainerHeader/index';
import IntlMessages from 'util/IntlMessages';
import { getIdentityOrgId } from 'services/Authentication';
import SurveyStatistic from './surveyStatistic/surveyStatistic';
import ProjectListItem from './projectListItem/projectListItem';
import { sortProjectsByWeight } from 'services/projectService';
import {
    getActiveSurveysCount,
    getInactiveSurveysCount,
} from 'services/SurveyService';

export class Component extends React.Component {

    onOptionMenuToggle = () => {
        this.setState({ menuState: !this.state.menuState });
    };
    handleRequestClose = () => {
        this.setState({ menuState: false });
    };

    constructor() {
        super();
        this.state = {
            menuState: false,
            cardHeight: 0, // set to 60+ if you want the graphs to show on the dashboard (does take up room)
        };
    }

    componentDidMount() {
        const { showOrgLoader, onOrgDashboard, fetchOrgsAndSelectOrg, fetchProjects, fetchOrgStatistics } = this.props;
        const orgid = getIdentityOrgId();
        showOrgLoader();
        fetchOrgsAndSelectOrg(orgid); // required if the org is updated - the org is updated but the whole list is required as well for the UI.
        fetchOrgStatistics(orgid);
        // projects have 2 components - local data and data we get from jira. use cache means get local data but use cache for jira data
        fetchProjects({ orgid, useCache: true });
        onOrgDashboard();
    }
    onProject = () => {
        history.push('/app/project/default');
    };

    // the next 2 go to the same view but the reducer will have different data to display
    onProjectCostPrioritiesDashboard = (project) => {
        this.props.onProjectPrioritiesDashboard(project);
        this.props.onProjectCostPrioritiesDashboard(project);
        history.push('/app/projectPriority/default');
    };

    onProjectBusinessPrioritiesDashboard = (project) => {
        this.props.onProjectPrioritiesDashboard(project);
        this.props.onProjectBusinessPrioritiesDashboard(project);
        history.push('/app/projectPriority/default');
    };

    render() {
        const { orgDashboardData, projectList, orgStatisticsData, selectedOrg } = this.props;
        const { cardHeight } = this.state;
        const orderProjectList = sortProjectsByWeight(projectList) ?.reverse() ?.slice(0, 5) || [];
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="ml-3 mt-2" id="orgDashboardHeader">
                    <ContainerHeader match={this.props.match} title={<IntlMessages id="sidebar.agile.dashboard.organisation" />} />
                </div>

                <div className="row ml-2 mr-2 mt-2">
                    <div className="col-lg-3 col-sm-6 col-12">
                        <ChartCard styleName="bg-secondary text-white">
                            <div className="chart-title">
                                <p>Employees</p>
                                {/* <h2>{`offline = ${process.env.API_SOURCE_SLS_OFFLINE}`}</h2> */}
                                <h2>1</h2>
                            </div>
                            <ResponsiveContainer width="100%" height={cardHeight}>
                                <BarChart data={data}>
                                    <Bar dataKey="pv" fill="white" />
                                    <Bar dataKey="uv" fill="white" />
                                </BarChart>
                            </ResponsiveContainer>
                        </ChartCard>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                        <ChartCard styleName="bg-primary text-white">
                            <div className="chart-title">
                                <p><IntlMessages id="dashboard.numberOfActiveSurveys" /></p>
                                <h2>{getActiveSurveysCount(selectedOrg ?.surveys)}</h2>
                            </div>
                            <ResponsiveContainer width="100%" height={cardHeight}>
                                <AreaChart data={data1} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                                    <Area type="monotone" dataKey="pv" stroke="rgba(255,255,255,0.5)"
                                        activeDot={{ r: 8 }}
                                        fillOpacity={.5}
                                        fill="white" />
                                </AreaChart>
                            </ResponsiveContainer>
                        </ChartCard>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                        <ChartCard styleName="bg-teal lighten-1 text-white">
                            <div className="chart-title">
                            <p><IntlMessages id="dashboard.numberOfInactiveSurveys" /></p>
                                <h2>{getInactiveSurveysCount(selectedOrg ?.surveys)}</h2>
                            </div>
                            <ResponsiveContainer width="100%" height={cardHeight}>
                                <LineChart data={data2}>
                                    <Line type="monotone" dataKey="uv" stroke="#ffffff" activeDot={{ r: 8 }} />
                                    <Line type="monotone" dataKey="pv" stroke="#ffffff" />
                                    <Line type="monotone" dataKey="amt" stroke="#ffffff" />
                                </LineChart>
                            </ResponsiveContainer>
                        </ChartCard>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                        <ChartCard styleName="bg-blue text-white">
                            <div className="chart-title">
                                <p><IntlMessages id="dashboard.numberOfProjects" /></p>
                                <h2>{orgStatisticsData ?.projectCount || 0}</h2>
                            </div>
                            <ResponsiveContainer width="100%" height={cardHeight}>
                                <LineChart data={data1}>
                                    <Line dataKey="uv" stroke="#ffffff" activeDot={{ r: 8 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </ChartCard>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="ml-3 mb-2"><ContainerHeader title={<IntlMessages id="orgDashboard.projectList" />} /></div>
                        <div className="animated slideInUpTiny animation-duration-3">
                            {orderProjectList.map((project, index) => (
                                <ProjectListItem
                                    key={index}
                                    data={project}
                                    onProjectCostPrioritiesDashboard={this.onProjectCostPrioritiesDashboard.bind(this, project)}
                                    onProjectBusinessPrioritiesDashboard={this.onProjectBusinessPrioritiesDashboard.bind(this, project)} />
                            ))}
                        </div>
                    </div>
                </div>
                {orgDashboardData ?.activeOrgSurveysSimpleChartData ?.length > 0 ?
                    (
                        <div className="row">
                            <div className="col-12" style={{ marginLeft: '20px', marginTop: '10px' }}>
                                <ContainerHeader title={<IntlMessages id="orgDashboard.activeSurveys" />} />
                            </div>
                            <div className="col-12">
                                {orgDashboardData ?.activeOrgSurveysSimpleChartData ?
                                    orgDashboardData.activeOrgSurveysSimpleChartData.map((data, index) => {
                                        return <SurveyStatistic key={index} data={data} />;
                                    })
                                    :
                                    <React.Fragment></React.Fragment>
                                }
                            </div>
                        </div>
                    ) : null
                }
                {orgDashboardData ?.inactiveOrgSurveysSimpleChartData ?.length > 0 ?
                    (
                        <div className="row">
                            <div className="col-12" style={{ marginLeft: '20px', marginTop: '10px' }}>
                                <ContainerHeader title={<IntlMessages id="orgDashboard.inActiveSurveys" />} />
                            </div>
                            <div className="col-12">
                                {orgDashboardData ?.inactiveOrgSurveysSimpleChartData ?
                                    orgDashboardData.inactiveOrgSurveysSimpleChartData.map((data, index) => {
                                        return <SurveyStatistic key={index} data={data} />;
                                    })
                                    :
                                    <React.Fragment></React.Fragment>
                                }
                            </div>
                        </div>
                    ) : null
                }
            </div>
        );
    }
}
export default Component;


// WEBPACK FOOTER //
// ./components/Agile/OrgDashboard/Component.js